import { render, staticRenderFns } from "./NewBaremModal.vue?vue&type=template&id=2672a487&scoped=true"
import script from "./NewBaremModal.vue?vue&type=script&lang=js"
export * from "./NewBaremModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2672a487",
  null
  
)

export default component.exports